import React from 'react';
import './anchorButton.css'

export default function AnchorButton({text, href}) {

    return (
        <a className="anchor-button" href={href}>
            <div className='button'>
                {text}
            </div>
        </a>
    );
}
